import { v4 as uuidv4 } from 'uuid';

export const makeUUID = uuidv4;
export const REFI_APPLY = 'c0c32147-fd5c-4edd-ad01-a5f667fba983';
export const REFI_MFE_UUID = {
  REFI_APPLY,
  makeUUID,
};
